import { h, Component } from 'preact';
import PrimaryLocation from '../primary-location';
import SearchForLocation, { SearchResults } from '../search-for-location';
import FavoriteLocations from '../favorite-locations';
import RecentLocations from '../recent-locations';
import LoadingText from '../loading-text';
import { Text } from 'preact-i18n';
import { Popover } from '@cube/blocks';
import style from './style';
import cx from 'classnames';

export default class LocationPopover extends Component {

	handlePopoverToggle = (active) => {
		this.setState({ active });
	};

	closePopover = () => {
		this.setState({ active: false });
	};

	handleSetCurrent = (...args) => {
		this.props.onSetCurrent && this.props.onSetCurrent(...args);
		this.closePopover();
	};

	handleAddFavorite = (...args) => {
		this.props.onAddFavorite && this.props.onAddFavorite(...args);
		this.closePopover();
	};

	render({
		pending,
		maxFavorites,
		maxRecent,
		primary = {},
		current = {},
		favorites = [],
		recent = [],
		searchResults,
		label,
		searchTerm,
		onSearchInput,
		onSetCurrent,
		onAddFavorite,
		onDismissFavorite,
		isFavoritesFull,
		isFavorite,
		...props
	}, { active }) {
		delete props.onChange;
		delete props.onChangeCurrent;
		delete props.onChangeFavorites;
		delete props.onChangeRecent;
		delete props.onChangeSearchTerm;

		return (
			<Popover
				anchor="right"
				{...props}
				active={active}
				onToggle={this.handlePopoverToggle}
				focusAfterClosing
				containerClass={cx(style.container, props.containerClass, props.class)}
				popoverClass={cx(style.popover, props.popoverClass)}
				toggleClass={cx(style.button, props.toggleClass)}
				text={(pending && <LoadingText color="gray" />) || label || current.name || <Text id="changeLocation" />}
				icon="cog-wire-cube"
				iconPosition="right"
			>
				<SearchForLocation value={searchTerm} onInput={onSearchInput} refocus={active} />
				{searchTerm && searchTerm.length ? (
					<SearchResults
						locations={searchResults}
						onSetCurrent={this.handleSetCurrent}
						onAddFavorite={!isFavoritesFull && this.handleAddFavorite}
						isFavorite={isFavorite}
						isFavoritesFull={isFavoritesFull}
					/>
				) : ([
					<PrimaryLocation location={primary} onSetCurrent={this.handleSetCurrent} />,
					<FavoriteLocations
						locations={favorites}
						maxFavorites={maxFavorites}
						onSetCurrent={this.handleSetCurrent}
						onDismissFavorite={onDismissFavorite}
					/>,
					Boolean(recent.length) && (
						<RecentLocations
							locations={recent}
							maxFavorites={maxFavorites}
							onSetCurrent={this.handleSetCurrent}
							onAddFavorite={!isFavoritesFull && this.handleAddFavorite}
							isFavoritesFull={isFavoritesFull}
						/>
					)
				])}
			</Popover>
		);
	}
}
